export default __webpack_public_path__ + "static/media/logo.00ee62ff.svg";